import { render } from "./HealthyTutorialBuddy.vue?vue&type=template&id=33810754&scoped=true"
import script from "./HealthyTutorialBuddy.vue?vue&type=script&lang=js"
export * from "./HealthyTutorialBuddy.vue?vue&type=script&lang=js"

import "./HealthyTutorialBuddy.vue?vue&type=style&index=0&id=33810754&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33810754"]])

export default __exports__